<template>
  <div>
    <!-- 搜索/新增 -->
    <div class="list-hd">
      <el-form :inline="true" v-model="searchValue" class="demo-form-inline">
        <el-form-item label="用户ID（多选可用,分开）:">
          <el-input v-model="searchValue.id"></el-input>
        </el-form-item>
        <el-form-item label="用户名:">
          <el-input v-model="searchValue.username"></el-input>
        </el-form-item>
        <el-form-item label="用户实名:">
          <el-input
            v-model="searchValue.real_name"
            placeholder="填写完整实名"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户身份证:">
          <el-input
            v-model="searchValue.id_card"
            placeholder="填写完整身份证"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号码:">
          <el-input v-model="searchValue.phone"></el-input>
        </el-form-item>
        <el-form-item label="游戏:">
          <el-select
            v-model="searchValue.game_id"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in gamesList"
              :value="item.id"
              :label="item.name"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="注册渠道:">
          <el-select
            v-model="searchValue.channel_id"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in channelSelectList"
              :value="item.id"
              :label="item.name"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态:">
          <el-select
            v-model="searchValue.status"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in userStatus"
              :value="item.id"
              :label="item.name"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="返利标记状态:">
          <el-select
            v-model="searchValue.is_rebate"
            clearable
            placeholder="全部"
          >
            <el-option label="已标记" :value="1"></el-option>
            <el-option label="未标记" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期:">
          <el-date-picker
            v-model="date"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
            :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="searchUsersList">搜索</el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="success" @click="exportUsers()">导出</el-button>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            plain
            :disabled="selectedRebateUsers.length === 0"
            :loading="batchRebateLoading"
            @click="confirmBatchToggleRebateUsers"
          >
            批量标记返利用户<span v-if="selectedRebateUsers.length">
              ({{ selectedRebateUsers.length }})</span
            >
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 用户列表展示 -->
    <el-table
      stripe
      ref="table"
      v-loading="loadingData"
      :data="tableData"
      row-key="id"
      :max-height="tableHeight"
      border
      style="width: 100%"
      @selection-change="handleRebateSelectionChange"
    >
      <el-table-column
        type="selection"
        width="55"
        fixed="left"
        reserve-selection
        :selectable="canSelectRebateUser"
      ></el-table-column>
      <el-table-column prop="id" label="ID" width="150"> </el-table-column>
      <el-table-column prop="created_at" label="注册时间"> </el-table-column>
      <el-table-column prop="username" label="账号"> </el-table-column>
      <el-table-column prop="game.name" label="游戏名称"> </el-table-column>
      <el-table-column prop="phone" label="手机号"> </el-table-column>
      <el-table-column prop="gender" label="性别"> </el-table-column>
      <el-table-column prop="real_name" label="实名"> </el-table-column>
      <el-table-column prop="id_card" label="身份证"> </el-table-column>
      <el-table-column prop="channels.name" label="注册渠道"> </el-table-column>
      <el-table-column prop="last_login_ip" label="最后登录IP">
      </el-table-column>
      <el-table-column prop="last_login_at" label="最后登录时间">
      </el-table-column>
      <el-table-column prop="sum_money" label="累计充值金额"> </el-table-column>
      <el-table-column prop="status" label="状态"> </el-table-column>
      <el-table-column label="返利标记状态" width="100">
        <template slot-scope="scope">
          <el-tag
            v-if="canToggleRebateUser(scope.row)"
            size="small"
            :class="[
              'rebate-status-tag',
              { 'is-loading': isRebateToggleLoading(scope.row.id) },
            ]"
            :type="isRebateUser(scope.row) ? 'success' : ''"
            role="button"
            tabindex="0"
            @click.native="confirmToggleRebateUser(scope.row)"
            @keyup.enter.native="confirmToggleRebateUser(scope.row)"
          >
            <i
              v-if="isRebateToggleLoading(scope.row.id)"
              class="el-icon-loading"
            ></i>
            {{
              isRebateToggleLoading(scope.row.id)
                ? "处理中"
                : isRebateUser(scope.row)
                ? "已标记"
                : "未标记"
            }}
          </el-tag>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="90">
        <template slot-scope="scope">
          <div class="user-table-actions">
            <router-link
              class="user-table-action-link"
              :to="{ name: 'userDetails', query: { id: scope.row.id } }"
            >
              <el-button type="primary" size="mini" plain>详情</el-button>
            </router-link>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalRecords"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { mapState } from "vuex";
import fetch from "@/assets/js/axios.js";
import { urlSplicing } from "@/assets/js/public.js";

// 允许标记返利的的游戏ID
const REBATE_SUPPORTED_GAME_IDS = [43];

export default {
  name: "users",
  components: {},
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > new Date(moment().format("YYYY-MM-DD") + ' 23:59:59').getTime()
        }
      },
      date: [
        moment().format("YYYY-MM-DD") + ' 00:00:00',
        moment().format("YYYY-MM-DD") + ' 23:59:59'
      ],
      loadingData: false,
      searchValue: {
        username: "",
        real_name: "",
        id_card: "",
        phone: "",
        status: "",
        is_rebate: "",
        game_id: "",
        channel_id: "",
      },
      userStatus: [
        {
          id: 0,
          name: "正常",
        },
        {
          id: 1,
          name: "禁用",
        },
      ],
      historyValue: "",
      tableHeight: 0,
      tableData: [],
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      gamesList:[],
      channelSelectList: [],
      rebateToggleLoading: {},
      selectedRebateUsers: [],
      batchRebateLoading: false,
    };
  },
  computed: {
    ...mapState(["host"]),
  },
  created() {
    this.getGameSelectList()
    this.getchannelSelectList()
    this.getUsersList(true);
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["table"].doLayout();
    });
  },
  beforeMount(height) {
    var h = document.documentElement.clientHeight;
    this.tableHeight = h - 60; //减去页面上固定高度height
  },
  methods: {
    clearRebateSelection() {
      this.selectedRebateUsers = [];
      if (this.$refs.table) {
        this.$refs.table.clearSelection();
      }
    },
    handleRebateSelectionChange(selection) {
      this.selectedRebateUsers = selection;
    },
    isRebateUser(row) {
      return Number(row.is_rebate) === 1;
    },
    isRebateToggleLoading(userId) {
      return Boolean(this.rebateToggleLoading[userId]);
    },
    canToggleRebateUser(row) {
      const gameId = row.game_id || (row.game && row.game.id);

      // return REBATE_SUPPORTED_GAME_IDS.indexOf(Number(gameId)) !== -1;
      // 先所有游戏都可以标记
      return true
    },
    canSelectRebateUser(row) {
      return this.canToggleRebateUser(row) && !this.isRebateUser(row);
    },
    requestToggleRebateUsers(userIds, isRebate) {
      return fetch({
        url: "/admin/rebate_monitor/toggle",
        method: "POST",
        data: {
          user_ids: userIds,
          is_rebate: isRebate,
        },
      });
    },
    confirmBatchToggleRebateUsers() {
      const rows = this.selectedRebateUsers.filter((row) =>
        this.canSelectRebateUser(row)
      );
      if (!rows.length) return;

      this.$confirm(`是否确认标记选中的${rows.length}个用户?`, "操作确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.batchToggleRebateUsers(rows);
        })
        .catch(() => {});
    },
    batchToggleRebateUsers(rows) {
      const userIds = rows.map((row) => row.id).join(",");
      this.batchRebateLoading = true;

      this.requestToggleRebateUsers(userIds, 1)
        .then((res) => {
          if (res.data.status) {
            rows.forEach((row) => {
              this.$set(row, "is_rebate", 1);
            });
            this.clearRebateSelection();
            this.$message.success(`成功标记${rows.length}个用户`);
          } else {
            this.$message.error(res.data.message || "批量标记失败");
          }
        })
        .finally(() => {
          this.batchRebateLoading = false;
        });
    },
    confirmToggleRebateUser(row) {
      if (!this.canToggleRebateUser(row)) return;
      if (this.isRebateToggleLoading(row.id)) return;

      const action = this.isRebateUser(row) ? "取消标记" : "标记";
      this.$confirm(`是否确认${action}该用户?`, "操作确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.toggleRebateUser(row);
        })
        .catch(() => {});
    },
    toggleRebateUser(row) {
      const requestIsRebate = this.isRebateUser(row) ? 0 : 1;
      this.$set(this.rebateToggleLoading, row.id, true);

      this.requestToggleRebateUsers(String(row.id), requestIsRebate)
        .then((res) => {
          if (res.data.status) {
            const listIsRebate = requestIsRebate === 1 ? 1 : 2;
            this.$set(row, "is_rebate", listIsRebate);
            if (requestIsRebate === 1 && this.$refs.table) {
              this.$refs.table.toggleRowSelection(row, false);
            }
            this.$message.success(
              requestIsRebate === 1 ? "标记成功" : "取消标记成功"
            );
          } else {
            this.$message.error(res.data.message || "操作失败");
          }
        })
        .finally(() => {
          this.$delete(this.rebateToggleLoading, row.id);
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getUsersList(false);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getUsersList(false);
    },
    // 实现游戏数据搜索
    searchUsersList() {
      this.clearRebateSelection();
      this.currentPage = 1;
      this.getUsersList(true);
    },
    // 游戏下拉选择
    getGameSelectList() {
      fetch({
        url: "/admin/games/select",
        method: "GET",
      }).then((res) => {
        this.gamesList = res.data.data;
      });
    },
    // 获取渠道选择列表数据
    getchannelSelectList(row) {
      fetch({
        url: "/admin/channels/select",
        method: "GET",
      }).then((res) => {
        this.channelSelectList = res.data.data;
      });
    },
    // 展示游戏列表数据
    getUsersList(reload = false) {
      let searchValue = {};
      if (reload) {
        this.historyValue = JSON.parse(JSON.stringify(this.searchValue));
        searchValue = this.searchValue;
      } else {
        searchValue = this.historyValue;
      }
      this.loadingData = true;
      const params = {
        ...searchValue,
        page: this.currentPage,
        per_page: this.pageSize,
        uid: searchValue.id,
      }
      if (this.date && this.date.length) {
        const created_from = this.date.length === 2 && this.date[0]
        const created_to = this.date.length === 2 && this.date[1]
        if (created_from) params['created_from'] = created_from
        if (created_to) params['created_to'] = created_to
      }
      fetch({
        url: "/admin/users/list",
        method: "GET",
        params,
      })
        .then((res) => {
          if (res.data.status) {
            this.tableData = res.data.data.data;
            this.totalRecords = res.data.data.total;
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    },

    // 导出
    exportUsers() {
      let params = {
        ...this.historyValue, // 传对应的搜索的值
        export: 1,
        token: sessionStorage.getItem("access_token"),
      }
      if (this.date && this.date.length) {
        const created_from = this.date.length === 2 && this.date[0]
        const created_to = this.date.length === 2 && this.date[1]
        if (created_from) params['created_from'] = created_from
        if (created_to) params['created_to'] = created_to
      }
      urlSplicing(this.host + "admin/users/list", params);
    },
  },
};
</script>
<style lang="less">
a {
  text-decoration: none;
  color: #606266;
}
.pagination {
  text-align: right;
  margin-top: 20px;
  padding-bottom: 20px;
}
.list-hd {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  .el-input-group {
    width: 370px;
  }
}
.rebate-status-tag {
  min-width: 58px;
  text-align: center;
  border-radius: 4px;
  cursor: pointer;
  user-select: none;
  transition: opacity 0.2s ease;
}
.rebate-status-tag:hover,
.rebate-status-tag:focus {
  opacity: 0.8;
  outline: none;
}
.rebate-status-tag:focus-visible {
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.25);
}
.rebate-status-tag.is-loading {
  cursor: not-allowed;
  opacity: 0.65;
}
.user-table-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}
.user-table-action-link {
  line-height: 1;
}
</style>
